export const  scrollToAnchor = (id:string, offset:number) => {
  // Check if we're on the main page already
  const isMainPage = window.location.pathname === '/';
  
  if (isMainPage) {
    // If already on main page, just scroll
    scrollToElement(id, offset);
  } else {
    // Navigate to main page first, then scroll
    window.location.href = `/#${id}`;
  }
}

// Helper function for scrolling to element
const scrollToElement = (id: string, offset: number) => {
  const targetElement = document.querySelector(`#${id}`);
  if (targetElement) {
    const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
  }